export default "__VITE_ASSET__C3g_rQBS__"